import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default observer(function TitleScore(props: { offer: BetOffer }) {
	const myBetsStore = useContext(MyBetsStoreContext);

	const getLiveEvent =
		myBetsStore?.activeEventsStore.eventsMap.get(props.offer.eventId) ||
		null;

	if (props.offer.formattedCurrentResult(getLiveEvent) == "") {
		return null;
	}

	return (
		<div className="bet__event__result bet__event__result--wrap">
			<div className="bet__event__current">
				{props.offer.formattedCurrentResult(getLiveEvent)}
			</div>

			{props.offer.scorePerPeriodString(getLiveEvent) != "" && (
				<div className="bet__event__period">
					{props.offer.scorePerPeriodString(getLiveEvent)}
				</div>
			)}
		</div>
	);
});
